export default __webpack_public_path__ + "static/media/layout-icon.7b0b3b5e.svg";